module.exports = __webpack_public_path__ + "static/6-dff7fcfdef759e1bee678236084ae0cb.jpg";